export default __webpack_public_path__ + "static/media/Playstore Logo.080186b1.png";